// Entrar con un código de /perfil, para equipos donde no se puede abrir Hattrick (migrations/018).

export {};  // módulo propio: evita choques de nombres globales con otras páginas en el type-check

const form = document.getElementById('login-code-form') as HTMLFormElement;
const input = document.getElementById('login-code-input') as HTMLInputElement;
const errorEl = document.getElementById('login-code-error') as HTMLElement;

// Abierto de entrada si se llega con /login#codigo
if (window.location.hash === '#codigo') {
    (document.getElementById('login-code') as HTMLDetailsElement).open = true;
    input.focus();
}

form.addEventListener('submit', async event => {
    event.preventDefault();
    errorEl.textContent = '';
    const button = form.querySelector('button') as HTMLButtonElement;
    button.disabled = true;
    try {
        const response = await fetch('/api/login/code', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ code: input.value }),
        });
        if (!response.ok) {
            const data = await response.json().catch(() => ({}));
            throw new Error(data.detail || `Error ${response.status}`);
        }
        window.location.href = '/';
    } catch (error) {
        errorEl.textContent = error instanceof Error ? error.message : String(error);
        button.disabled = false;
    }
});
